/* menu.js — el panel de la hamburguesa.

   Mismo comportamiento que el cajón del carrito, del otro lado: fondo, Escape, foco que
   vuelve a donde estaba, y el foco atrapado dentro mientras está abierto (si no, tabular
   te saca a la página de atrás sin que se note).

   Sin JS esto no corre, pero nadie queda encerrado: el menú de pantalla grande y el pie
   llevan a los mismos sitios. */
(function () {
  var panel = document.getElementById('menu-panel');
  var fondo = document.getElementById('panel-fondo');
  var abrirBtn = document.getElementById('abrir-menu');
  var cerrarBtn = document.getElementById('cerrar-menu');
  if (!panel || !abrirBtn) return;

  // El panel se muda a <body>. Nace dentro de la cabecera (que vive en .escena), y .escena
  // tiene z-index:3 → crea contexto de apilamiento, así que el z-index:71 del panel vale 3
  // frente a la raíz y los botones flotantes (55, hijos directos de body) se pintaban ENCIMA
  // del velo y del menú. El cajón del carrito no lo sufre porque ya está fuera: esa
  // asimetría es la prueba. Mudarlo es el mismo truco que usa intro.js con sus capas.
  if (panel.parentNode !== document.body) document.body.appendChild(panel);
  if (fondo && fondo.parentNode !== document.body) document.body.appendChild(fondo);

  var ultimoFoco = null;

  function enfocables() {
    return [].filter.call(
      panel.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])'),
      function (e) { return e.offsetParent !== null || e === document.activeElement; });
  }

  function abrir() {
    ultimoFoco = document.activeElement;
    panel.hidden = false; if (fondo) fondo.hidden = false;
    document.body.classList.add('panel-abierto');
    abrirBtn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      panel.classList.add('visible'); if (fondo) fondo.classList.add('visible');
      if (cerrarBtn) cerrarBtn.focus();
    });
  }

  function cerrar() {
    panel.classList.remove('visible'); if (fondo) fondo.classList.remove('visible');
    document.body.classList.remove('panel-abierto');
    abrirBtn.setAttribute('aria-expanded', 'false');
    setTimeout(function () { panel.hidden = true; if (fondo) fondo.hidden = true; }, 300);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  abrirBtn.addEventListener('click', abrir);
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrar);
  if (fondo) fondo.addEventListener('click', cerrar);

  document.addEventListener('keydown', function (ev) {
    if (panel.hidden) return;
    if (ev.key === 'Escape') return void cerrar();
    if (ev.key !== 'Tab') return;
    var f = enfocables();
    if (!f.length) return;
    var primero = f[0], ultimo = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === primero) { ev.preventDefault(); ultimo.focus(); }
    else if (!ev.shiftKey && document.activeElement === ultimo) { ev.preventDefault(); primero.focus(); }
  });

  // Si se agranda la ventana, el menú de escritorio ya está a la vista: el panel sobra.
  window.addEventListener('resize', function () {
    if (!panel.hidden && window.innerWidth > 860) cerrar();
  });

  var cab = document.getElementById('cabecera');
  if (cab) {
    // El banner se despega del fondo al hacer scroll: se lee como capa, no como estorbo.
    var marcar = function () { cab.classList.toggle('desplazado', window.scrollY > 10); };
    window.addEventListener('scroll', marcar, { passive: true });
    marcar();

    // El alto del banner NO se puede fijar en CSS: el logo es configurable desde el panel y
    // un número inventado acabaría tapando el primer título. Se mide y se devuelve como
    // padding del body. El valor del CSS es solo el arranque antes de que esto corra.
    // Se escribe SOLO si el alto cambió de verdad. En móvil, la barra de direcciones
    // dispara «resize» en cada scroll: reescribir la variable en cada uno invalidaba el
    // estilo de .escena (que la usa de padding-top) y hacía parpadear la página entera.
    var ultimo = -1;
    var medir = function () {
      var alto = cab.offsetHeight;
      if (alto === ultimo || !alto) return;
      ultimo = alto;
      document.documentElement.style.setProperty('--alto-cabecera', alto + 'px');
    };
    medir();
    window.addEventListener('resize', medir);
    if (window.ResizeObserver) new ResizeObserver(medir).observe(cab);
    // El logo puede llegar después que el script y cambiar el alto al pintarse.
    var logo = cab.querySelector('.marca-logo');
    if (logo && !logo.complete) logo.addEventListener('load', medir);
  }
})();
